// 📁 src/hooks/useUpcomingVolunteerShift.js
import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../auth_context";
import { useEventContext } from "./use_event_context";

export const useUpcomingVolunteerShift = () => {
  const { user } = useAuth();
  const { eventId } = useEventContext();
  const [hasUpcomingShift, setHasUpcomingShift] = useState(false);

  useEffect(() => {
    const checkShifts = async () => {
      if (!user?.email || !eventId) return;

      const now = new Date();
      const in48Hours = new Date(now.getTime() + 48 * 60 * 60 * 1000);

      try {
        const activitiesSnap = await getDocs(collection(db, "events", eventId, "volunteers"));

        for (const docSnap of activitiesSnap.docs) {
          const slotsRef = collection(db, "events", eventId, "volunteers", docSnap.id, "timeSlots");
          const slotsSnap = await getDocs(query(slotsRef, where("assignedTo", "==", user.email)));

          const hasShift = slotsSnap.docs.some((doc) => {
            const start = doc.data().start?.toDate?.();
            return start && start >= now && start <= in48Hours;
          });

          if (hasShift) {
            setHasUpcomingShift(true);
            return;
          }
        }
      } catch (err) {
        console.warn("⚠️ Error checking volunteer shifts", err);
      }
    };

    checkShifts();
  }, [user?.email, eventId]);

  return hasUpcomingShift;
};
